import cn from 'classnames';
import Immutable from 'immutable';
import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { getIconForFormat } from '@bibliocommons/utils-format';
import { metadataIdFixer } from '@bibliocommons/utils-link';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import * as Icons from '@bibliocommons/base-icons';
import manageFocus from '@bibliocommons/base-accessibility-manage-focus';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { Generic } from '@bibliocommons/shared-messages';
import { ShelfMessage } from '../../shared/Messages';
import { TextButton } from '@bibliocommons/base-buttons';
import AvailabilityBibBlock from '@bibliocommons/availability-bib-block';

import FormatInfo from '../../../containers/FormatInfoContainer';
import AddToShelfButtonContainer from '../../../containers/AddToShelfButtonContainer';
import GroupingSummary from '../../search/GroupingSummary';
import ItemTransactionButtonContainer from '../../../containers/ItemTransactionButtonContainer';
import GroupSearchFeedbackButton from '../../GroupSearchFeedbackButton';
import MessagingContainer from '../../../containers/shared/Messaging/MessagingContainer';
import WorkflowContainer from '../../../containers/WorkflowContainer';
import './ManifestationListItem.scss';

class ManifestationListItem extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleToggleClick', 'renderGroupSummary', 'renderManifestationItemToggle');
    this.state = {
      transactionButtonToggleOpen: this.props.drawerOpen || false
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.transactionButtonToggleOpen && !prevState.transactionButtonToggleOpen) {
      this.props.captureFocus(this._actionDrawer, false);
    } else {
      this.props.restoreFocus();
    }
  }

  handleToggleClick(e) {
    e.preventDefault();

    return this.setState({
      transactionButtonToggleOpen: !this.state.transactionButtonToggleOpen
    });
  }

  renderGroupSummary(item) {
    const { catalogSearchOptions, groupSearchFeedbackActions, showGroupingDebug } = this.props;
    if (catalogSearchOptions.get('showGroupings') && showGroupingDebug) {
      return (
        <div className="manifestation-item-debug-actions hidden-xs">
          <GroupingSummary groupSummary={item.get('groupSearchSummary')} />
          <GroupSearchFeedbackButton handleClick={groupSearchFeedbackActions.startGroupSearchFeedback} bib={item} />
        </div>
      );
    }
    return null;
  }

  renderManifestationItemToggle() {
    const { transactionButtonToggleOpen } = this.state;
    const { editable } = this.props;
    const itemId = this.props.item.get('id');
    const toggleIcon = editable ? <Icons.PencilEdit width={20} height={20} color="#02729e" /> : <Icons.More width={20} height={20} color="#02729e" />;

    return (
      <div className={cn('manifestation-item-action-toggle', 'hidden-sm hidden-md hidden-lg', { 'visible-xs toggled-open': transactionButtonToggleOpen })}>
        <TextButton handleClick={this.handleToggleClick} id={`manifestation-item-action-wrap-${itemId}`} aria-expanded={transactionButtonToggleOpen}>
          { toggleIcon }
          <ScreenReaderMessage>
            <FormattedMessage id="ada_toggle_manifestation_item_actions" />
          </ScreenReaderMessage>
        </TextButton>
      </div>
    );
  }

  render() {
    const { item, showHoldCount } = this.props;
    const { transactionButtonToggleOpen } = this.state;
    const itemId = item.get('id');
    const bibTitle = item.getIn(['briefInfo', 'title']);
    const status = item.getIn(['availability', 'status']);

    return (
      <WorkflowContainer id={itemId}>
        {(workflowComponent) => workflowComponent || (
          <div className="manifestation-item cp-manifestation-list-item row" key={itemId}>
            <MessagingContainer id={itemId}>
              {
                (messageOptions, dispatch) => messageOptions.message.get('type') === 'SHELF'
                  ? <ShelfMessage {...messageOptions} dispatch={dispatch} values={messageOptions.message.get('values', Immutable.Map()).merge({ title: bibTitle, username: this.props.currentUser.get('name') })} />
                  : <Generic {...messageOptions} values={messageOptions.message.get('values', Immutable.Map()).merge({ title: bibTitle })} />
              }
            </MessagingContainer>
            <div className={`manifestation-item-format-call-wrap ${status.toLowerCase()}`}>
              <div className="manifestation-item-format-info-wrap">
                <span className={getIconForFormat(item.getIn(['briefInfo', 'format']))} aria-hidden />
                <a
                  href={`/item/show/${metadataIdFixer(itemId)}`}
                  target="_parent" lang={item.get('primaryLanguage')}
                  rel="noopener"
                  data-test-id={`item-link-${itemId}`}
                  data-key="bib-manifestation-item-link">
                  <FormatInfo item={item} className="manifestation-item-format-info" searchScopeIsCurrent={this.props.searchScopeIsCurrent} />
                </a>
              </div>
              <div className="manifestation-item-availability-block-wrap">
                <AvailabilityBibBlock
                  bib={item}
                  availabilityStatus={item.get('availability')}
                  availabilityDetail={this.props.availabilityDetail}
                  availabilityDetailActions={this.props.availabilityDetailActions}
                  showHoldCount={showHoldCount} />
              </div>
            </div>
            { this.renderManifestationItemToggle() }
            <div
              className={`manifestation-item-action-wrap ${transactionButtonToggleOpen ? 'toggled-open' : ''}`}
              ref={(el) => { this._actionDrawer = el; }}>
              <div className="add-to-shelf-wrap">
                <AddToShelfButtonContainer metadataId={itemId} />
              </div>
              <ItemTransactionButtonContainer id={itemId} messagingId={itemId} />
              {this.renderGroupSummary(item)}
            </div>
          </div>
        )}
      </WorkflowContainer>
    );
  }
}

ManifestationListItem.PropTypes = {
  availabilityDetail:        ImmutablePropTypes.map,
  availabilityDetailActions: PropTypes.objectOf(PropTypes.func),
  catalogSearchOptions:      ImmutablePropTypes.map,
  currentUser:               ImmutablePropTypes.map,
  item:                      ImmutablePropTypes.map,
  drawerOpen:                PropTypes.bool,
  showHoldCount:             PropTypes.bool
};

export default manageFocus(ManifestationListItem);



// WEBPACK FOOTER //
// ./app/components/search/ManifestationListItem/ManifestationListItem.jsx